import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Chip, Stack, Typography } from "@octopus-energy/coral/atoms"
import { type ISbStoriesParams, type ISbStoryData } from "@storyblok/react"
import { PageLoader } from "@/components/organisms"
import { getQuerylessPath } from "@/lib/routes"
import { fetchSbStories } from "../../lib/api"
import { getStoryHref } from "../../utils/getStoryHref"

type StoryblokCategoriesProps = {
    options: ISbStoriesParams
}

export function StoryblokCategories({ options }: StoryblokCategoriesProps) {
    const [categories, setCategories] = useState<ISbStoryData[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const router = useRouter()
    const isCategorySelected = (category: ISbStoryData) =>
        `/${category.full_slug}` === `${getQuerylessPath(router.asPath)}/`

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categories: ISbStoryData[] = await fetchSbStories(options)
                setCategories(categories)
            } catch (error) {
                console.error(`Could not find categories`, error)
            }

            setIsLoading(false)
        }

        void fetchCategories()
    }, [options])

    if (isLoading) return <PageLoader />

    if (categories.length > 0) {
        return (
            <>
                <Typography>Filtrer par catégorie</Typography>
                <Stack
                    gap="sm"
                    flexWrap="wrap"
                >
                    {categories.map((category) => (
                        <Chip
                            href={getStoryHref(category)}
                            key={category.uuid}
                            color={isCategorySelected(category) ? "primary500" : "secondary500"}
                        >
                            {category.name}
                        </Chip>
                    ))}
                </Stack>
            </>
        )
    }
}
